// Ohio State App Fall 2025 Metrics

export const adoptionData = {
  undergraduate: {
    appUsers: 51813,
    totalEnrollment: 52533,
    percentage: 98.6
  },
  graduate: {
    appUsers: 9390,
    totalEnrollment: 11463,
    percentage: 81.9
  },
  professional: {
    appUsers: 2347,
    totalEnrollment: 3239,
    percentage: 72.5
  },
  total: {
    appUsers: 63550,
    totalEnrollment: 67235
  }
};

export const topScreens = [
  { name: 'For You', uniqueUsers: 190429, screenViews: 29292345 },
  { name: 'Search', uniqueUsers: 102769, screenViews: 1851641 },
  { name: 'To-Dos', uniqueUsers: 95041, screenViews: 942194 },
  { name: 'Calendar', uniqueUsers: 85289, screenViews: 8363143 },
  { name: 'Classes Meeting Detail', uniqueUsers: 82047, screenViews: 6996032 },
  { name: 'BuckID Accounts', uniqueUsers: 82830, screenViews: 1349601 },
  { name: 'Campus (Combined)', uniqueUsers: 140371, screenViews: 8085343 },
  { name: 'Announcements', uniqueUsers: 79084, screenViews: 472144 },
  { name: 'Grades', uniqueUsers: 77883, screenViews: 2727507 },
  { name: 'Schedule', uniqueUsers: 76039, screenViews: 1317228 },
  { name: 'Get Help', uniqueUsers: 71032, screenViews: 461167 },
  { name: 'Building Detail', uniqueUsers: 70675, screenViews: 1030629 },
  { name: 'Academic Calendar', uniqueUsers: 70371, screenViews: 325463 },
  { name: 'Digital BuckID', uniqueUsers: 64641, screenViews: 550412 },
  { name: 'Statement of Account', uniqueUsers: 61682, screenViews: 1170239 },
  { name: 'Carmen Courses', uniqueUsers: 61039, screenViews: 1176247 },
  { name: 'Buses (Combined)', uniqueUsers: 54349, screenViews: 11087946 },
  { name: 'Get Involved', uniqueUsers: 50246, screenViews: 523707 },
  { name: 'Parking Permits', uniqueUsers: 31091, screenViews: 431300 },
  { name: 'Library Room Reservations', uniqueUsers: 28436, screenViews: 182947 }
];

export const libraryReservations = {
  totalReservations: 27000,
  topRooms: [
    { name: 'THO 040A', reservations: 1448, percentage: 5.4 },
    { name: '18th Ave Group Study Room 401', reservations: 1273, percentage: 4.7 },
    { name: 'THO 045A', reservations: 1201, percentage: 4.4 },
    { name: 'THO 045B', reservations: 1196, percentage: 4.4 },
    { name: '18th Ave Group Study Room 403', reservations: 1160, percentage: 4.3 }
  ]
};

export const engagementMetrics = {
  peakDailyScreenViews: 2200000,
  peakDate: 'August 25-27, 2025',
  consistentEngagement: true
};
